module.exports = __webpack_public_path__ + "static/media/DMZ1.446776b2.webp";